import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";
import ImageButtonList from "../common/imageButtonList";

class OptionsList extends Component {
  /*******************
   * Private methods *
   *******************/

  handleItemSelection = (id) => {
    let optionsListName = this.state.currentPatient;
    // check true/false on selected button for current patient
    this.setState({
      [optionsListName]: this.state[optionsListName].map((option) => {
        if (option.id === id) {
          return Object.assign({}, option, { checked: !option.checked });
        } else {
          return option;
        }
      }),
    });
  };

  handleKeyUp = (index, key) => {
    if (key === "ArrowUp") {
      index = index - 1;
      console.log(index);
    } else if (key === "ArrowDown") {
      index = index + 1;
      console.log(index);
    } else {
      return;
    }
  };

  /**************
   * Properties *
   **************/
  state = {
    currentPatient: this.props.currentPatient,
    arrowUp: require("../common/images/Arrow_up.png"),
    arrowDown: require("../common/images/Arrow_down.png"),
    textImage: require("./images/1348_Requests_elements.png"),
    requestsSubmit: require("./images/1348_Requests_submit_btn.png"),
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
    default: [
      {
        id: "option1",
        highlight: require("./images/1348_Financial_HL.png"),
        unhighlight: require("./images/1348_Financial_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option2",
        highlight: require("./images/1348_Chaplain_HL.png"),
        unhighlight: require("./images/1348_Chaplain_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option3",
        highlight: require("./images/1348_Social_HL.png"),
        unhighlight: require("./images/1348_Social_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option4",
        highlight: require("./images/1348_Housekeeping_HL.png"),
        unhighlight: require("./images/1348_Housekeeping_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
    chfPatient: [
      {
        id: "option1",
        highlight: require("./images/1348_Financial_HL.png"),
        unhighlight: require("./images/1348_Financial_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option2",
        highlight: require("./images/1348_Chaplain_HL.png"),
        unhighlight: require("./images/1348_Chaplain_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option3",
        highlight: require("./images/1348_Social_HL.png"),
        unhighlight: require("./images/1348_Social_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option4",
        highlight: require("./images/1348_Housekeeping_HL.png"),
        unhighlight: require("./images/1348_Housekeeping_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
    orthoPatient: [
      {
        id: "option1",
        highlight: require("./images/1348_Financial_HL.png"),
        unhighlight: require("./images/1348_Financial_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option2",
        highlight: require("./images/1348_Chaplain_HL.png"),
        unhighlight: require("./images/1348_Chaplain_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option3",
        highlight: require("./images/1348_Social_HL.png"),
        unhighlight: require("./images/1348_Social_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option4",
        highlight: require("./images/1348_Housekeeping_HL.png"),
        unhighlight: require("./images/1348_Housekeeping_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
    pediatricPatient: [
      {
        id: "option1",
        highlight: require("./images/1348_ChildLifeSpecialist_HL.png"),
        unhighlight: require("./images/1348_ChildLifeSpecialist_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option2",
        highlight: require("./images/1348_PetTherapy_HL.png"),
        unhighlight: require("./images/1348_PetTherapy_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: "option3",
        highlight: require("./images/1348_Housekeeping_HL.png"),
        unhighlight: require("./images/1348_Housekeeping_UH.png"),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
  };

  handleSubmit = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    let optionsListName = this.state.currentPatient;
    switch (event.key) {
      case "1":
        const hasSelectedOption = this.state[optionsListName].some(
          ({ checked }) => checked
        );
        if (hasSelectedOption) {
          this.props.history.push("/requests/success");
        }
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for a component that will mount.
   *
   * This method will add the appropriate key listeners.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleSubmit, false);
  }

  /**
   * Performs various actions for a component that will unmount.
   *
   * This method will remove the appropriate key listeners.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleSubmit);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let patient = null;
    switch (this.state.currentPatient) {
      case "orthoPatient":
        patient = this.state.orthoPatient;
        break;
      case "chfPatient":
        patient = this.state.chfPatient;
        break;
      case "pediatricPatient":
        patient = this.state.pediatricPatient;
        break;
      default:
        patient = this.state.default;
    }
    return (
      <div className="options">
        <ImageText id="text" src={this.state.textImage} />
        <ImageButtonList
          imageButtons={patient}
          flexClass="flex-vertical"
          handleKeyUp={this.handleKeyUp}
        />
        <img
          className="requests-submit"
          src={this.state.requestsSubmit}
          alt=""
        />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedOptionsList = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(OptionsList);

export default withRouter(ConnectedOptionsList);
